export default __webpack_public_path__ + "static/media/spotify_logo.0c4ae91b.png";